var map = {
	"./3dcapsule.png": 43,
	"./3dtriangle.png": 42,
	"./3dtube.png": 41,
	"./513906855_17843153880530050_5745062199497274673_n.jpg": 44,
	"./Arrow Right.svg": 35,
	"./Design.svg": 55,
	"./Develope.svg": 56,
	"./Support.svg": 57,
	"./Website Image-1.png": 58,
	"./Website Image-2.png": 59,
	"./Website Image-3.png": 60,
	"./arrow-up.svg": 25,
	"./avatar-.png": 61,
	"./avatar-1.jpg": 45,
	"./avatar-2.jpg": 46,
	"./avatar-3.jpg": 47,
	"./avatar-4.jpg": 48,
	"./avatar.jpg": 49,
	"./blob purple.png": 33,
	"./blob white.png": 34,
	"./blobPink.png": 32,
	"./envelope-open-solid.svg": 26,
	"./facebook-square-brands.svg": 50,
	"./hand.svg": 40,
	"./human.svg": 39,
	"./instagram-square-brands.svg": 23,
	"./linkedin-brands.svg": 62,
	"./logo.png": 27,
	"./logo.svg": 28,
	"./logo1.PNG": 63,
	"./logo2.png": 64,
	"./mobile.svg": 36,
	"./rocket image.png": 38,
	"./snapchat-square-brands.svg": 51,
	"./twitter-square-brands.svg": 29,
	"./waves.svg": 37
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 54;